import React from 'react';
import useDocumentTitle from '../useDocumentTitle'
import img_assembly from '../../img/assembly.png'
import img_insert_ui from '../../img/insert_ui.png'
import img_assembly_fix from '../../img/assembly_fix.png'
import img_mate_ball from '../../img/mates/ball.png'
import img_mate_cylindrical from '../../img/mates/cylindrical.png'
import img_mate_fasten from '../../img/mates/fasten.png'
import img_mate_fasten_ui from '../../img/mates/fasten_ui.png'
import img_mate_parallel from '../../img/mates/parallel.png'
import img_mate_pin_slot from '../../img/mates/pin_slot.png'
import img_mate_planar from '../../img/mates/planar.png'
import img_mate_revolute from '../../img/mates/revolute.png'
import img_mate_revolute_ui from '../../img/mates/revolute_ui.png'
import img_mate_slider from '../../img/mates/slider.png'
import img_mate_tangent from '../../img/mates/tangent.png'

import NavbarLearn from '../navbarLearn';
import Sidebar from '../learnSidebar';

export default function ThreeF() {
    useDocumentTitle("Chapter 3 Lesson F | 101Learn by the Spartabots")
    return (
        <div>
            <NavbarLearn />
            <div class="flex max-w-[100rem] mx-auto my-5 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[2rem] items-center">
                <p class="font-scoutcond font-black italic text-white opacity-50 text-[30rem] ml-10 leading-none">03-F</p>
                <h class="z-20 absolute font-scoutcond font-black italic text-frcblue text-[10rem] ml-40 leading-none">INTRO TO ASSEMBLY</h>
                <p class="absolute ml-[9.4rem] mt-44 font-scoutcond font-black italic text-white text-[4rem] leading-none">LESSON 3-F</p>
            </div>
            <div class="flex flex-row max-w-[100rem] mx-auto mb-5">
                <div class="hidden md:flex basis-80 bg-gray-300 rounded-l-[2rem]">
                    <Sidebar />
                </div>
                <div class="basis-full h-full bg-gray-50 rounded-r-[2rem]">
                    <div class="mx-10 my-10">
                        <h class="font-scoutcond font-black italic text-[5rem] leading-none">LESSON OVERVIEW</h>
                        <p class="font-productsans font-bold text-3xl text-gray-400">Familiarize yourself with the Assembly</p>
                        <p class="font-productsans text-base text-black mt-5">This lesson will explain the general layout of Onshape's UI - to skip ahead, click on the chapter roadmap below:</p>
                        <a href="/learn/three">
                            <p class="font-avenir font-bold text-base text-frcblue mt-10 leading-none">CHAPTER 3</p>
                            <p class="font-scoutcond font-black text-[3rem] leading-none">INTRODUCTION TO ONSHAPE</p>
                        </a>
                        <div class="border-l-2 ml-5">
                            <ul class="font-productsans font-bold ml-3">
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/a">What is Onshape?</a>
                                    <p class="font-productsans font-normal ml-3">Understand what Onshpae is and what it's used for.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/b">Setting up Onshape</a>
                                    <p class="font-productsans font-normal ml-3">Learn how to set up an Onshape account and get added to your team.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/c">Introduction to Sketching</a>
                                    <p class="font-productsans font-normal ml-3">Understand the concept of sketching within Onshape's Part Studio.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/d">Constraints</a>
                                    <p class="font-productsans font-normal ml-3">Learn how to constrain your sketches. Blue is bad.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/e">Introduction to Extrudes</a>
                                    <p class="font-productsans font-normal ml-3">Learn the basics of extruding a sketch into a 3D part.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-frcpurple" href="/learn/three/f">Introduction to the Assembly</a>
                                    <p class="font-productsans font-normal ml-3">Introduce yourself to Assembly. This might come as a surprise, but it's where you assemble stuff.</p>
                                </li>
                            </ul>
                        </div>
                        <h class="block font-scoutcond font-black italic text-[5rem] leading-none mt-20">THE ASSEMBLY</h>
                        <p class="font-productsans text-lg text-black">The assembly is where you “assemble” different “parts” that you have created in the Part Studio.
                        </p>
                        <p class="font-productsans text-lg text-black">The Assembly can be found at the bottom of the screen by clicking on the tab labeled "Assembly 1." Click on the
                            assembly and you will be shown to this empty screen:
                        </p>
                        <img src={img_assembly} class="my-5 rounded-[1rem]" alt="Screenshot of the Assembly"></img>
                        <p class="font-productsans text-lg text-black mt-5">In order to assemble individual parts into whole mechanisms, you must use the following steps:
                            <ul class="ml-5">
                                <li>
                                    <p>- Insert the parts that you've made.</p>
                                </li>
                                <li>
                                    <p>- Import other parts that you might need.</p>
                                </li>
                                <li>
                                    <p>- Fix one of the parts to the 3D plane.</p>
                                </li>
                                <li>
                                    <p>- Mate the parts together.</p>
                                </li>
                            </ul>
                        </p>
                        <p class="font-productsans text-lg text-black font-bold mt-5">Steps 1 & 2:
                        </p>
                        <p class="font-productsans text-lg text-black">Click the insert button at the top left of the screen. This gives us an interface:
                        </p>
                        <img src={img_insert_ui} class="my-5 rounded-[1rem]" alt="Screenshot of the Insert UI"></img>
                        <p class="font-productsans text-lg text-black">These parts are directly from the part studio that we made earlier. Click the green arrow after you are done to
                            confirm. If you want to add items from other documents, or would like to add nuts and bolts, select the “Other Documents” tab, or “Standard Content” tab. Follow the
                            same steps as above to insert the parts.
                        </p>
                        <p class="font-productsans text-lg text-black font-bold mt-5">Step 3:
                        </p>
                        <p class="font-productsans text-lg text-black">Right click one of the parts that you have just imported and find fix. This ensures that it can't move around
                            freely, helping you assemble with more ease.
                        </p>
                        <img src={img_assembly_fix} class="my-5 rounded-[1rem]" alt="Screenshot of how to fix a part"></img>
                        <p class="font-productsans text-lg text-black font-bold mt-5">Step 4:
                        </p>
                        <p class="font-productsans text-lg text-black">There are many different types of mates in Onshape that declare the relationship between two parts. Some allow for
                            the entire assembly to rotate, translate, etc. This is useful for when you want a visual representation of your final mechanism.
                            <ul class="ml-5">
                                <li>
                                    <p class="text-frcblue mt-5 font-bold">Fastened Mate</p>
                                    <img src={img_mate_fasten} class="my-5 rounded-[1rem]" alt="Screenshot of the Fasten icon on the toolbar"></img>
                                    <ul class="ml-8">
                                        <li>
                                            <p>Mates two entities and removes all degrees of freedom between them. This is the most basic type of mate. The popup is as follows:</p>
                                            <img src={img_mate_fasten_ui} class="my-5 rounded-[1rem]" alt="Screenshot of the Fasten UI"></img>
                                            <p class="mt-5">Here, you can select the direction, angle, and offset.</p>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <p class="text-frcblue mt-5 font-bold">Revolute Mate</p>
                                    <img src={img_mate_revolute} class="my-5 rounded-[1rem]" alt="Screenshot of the Revolute icon on the toolbar"></img>
                                    <ul class="ml-8">
                                        <li>
                                            <p>Mate two entities allowing rotational movement about the Z axis. The interface is similar, but you can set limits of rotation.</p>
                                            <img src={img_mate_revolute_ui} class="my-5 rounded-[1rem]" alt="Screenshot of the Revolute UI"></img>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <p class="text-frcblue mt-5 font-bold">Slider Mate</p>
                                    <img src={img_mate_slider} class="my-5 rounded-[1rem]" alt="Screenshot of the Slider icon on the toolbar"></img>
                                    <ul class="ml-8">
                                        <li>
                                            <p>Slider mates join two entities allowing translational movement along the z-axis. The first mate connector serves as the sliding point and the
                                                second mate connector serves as the stationary point.</p>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <p class="text-frcblue mt-5 font-bold">Planar Mate</p>
                                    <img src={img_mate_planar} class="my-5 rounded-[1rem]" alt="Screenshot of the Planar icon on the toolbar"></img>
                                    <ul class="ml-8">
                                        <li>
                                            <p>Planar mate allows translational movement along the x- and the y-axis and rotational movement about the x-axis.
                                                For example, imagine a plate on a table. It is able to slide around and rotate.</p>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <p class="text-frcblue mt-5 font-bold">Cylindrical Mate</p>
                                    <img src={img_mate_cylindrical} class="my-5 rounded-[1rem]" alt="Screenshot of the Cylindrical icon on the toolbar"></img>
                                    <ul class="ml-8">
                                        <li>
                                            <p>Mates two entities allowing translational movement along the z-axis and rotational movement about the z-axis.</p>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <p class="text-frcblue mt-5 font-bold">Pin Slot Mate</p>
                                    <img src={img_mate_pin_slot} class="my-5 rounded-[1rem]" alt="Screenshot of the Pin Slot icon on the toolbar"></img>
                                    <ul class="ml-8">
                                        <li>
                                            <p>Mates two entities allowing rotational movement about the z-axis and translational movement along the x-axis.</p>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <p class="text-frcblue mt-5 font-bold">Ball Mate</p>
                                    <img src={img_mate_ball} class="my-5 rounded-[1rem]" alt="Screenshot of the Ball icon on the toolbar"></img>
                                    <ul class="ml-8">
                                        <li>
                                            <p>Mates two entities, allowing rotational movement only.</p>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <p class="text-frcblue mt-5 font-bold">Parallel Mate</p>
                                    <img src={img_mate_parallel} class="my-5 rounded-[1rem]" alt="Screenshot of the Parallel icon on the toolbar"></img>
                                    <ul class="ml-8">
                                        <li>
                                            <p>Mates two entities allowing individual translational movement along any axis and parallel rotation along any axis.</p>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <p class="text-frcblue mt-5 font-bold">Tangent Mate</p>
                                    <img src={img_mate_tangent} class="my-5 rounded-[1rem]" alt="Screenshot of the Tangent icon on the toolbar"></img>
                                    <ul class="ml-8">
                                        <li>
                                            <p>Attach any two entities tangent to the selected faces or edges.</p>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}